// import qrcode from 'qrcode';
import QrCodeWithLogo from 'qr-code-with-logo';
import logo from '@/assets/department/logo.png';
import logoX2 from '@/assets/department/logo_x2.png';
import logoTxt from '@/assets/logo_txt.png';
import logoTxtX2 from '@/assets/logo_txt_x2.png';
import modeQrBg from '@/assets/mode_qr_bg.png';
import modeQrBgX2 from '@/assets/mode_qr_bg_x2.png';

export default {
  name: 'Qrcode',
  props: {
    url: {
      type: String,
      required: true,
      default: '',
    },
    patientName: {
      type: String,
      required: false,
      default: '',
    },
    departmentName: {
      type: String,
      required: false,
      default: '',
    },
  },
  mounted() {
    if (this.url) {
      QrCodeWithLogo.toCanvas({
        canvas: this.$refs.qrImg,
        content: this.url,
        width: 200,
        nodeQrCodeOptions: {
          margin: 2,
        },
        logo: {
          src: logo,
          logoSize: 0.25,
          logoRadius: 3,
          borderRadius: 3,
          bgColor: 'transparent'
        }
      }).then(_ => {
        const canvases = document.getElementById('qrcode');
        const qrCanvas = document.getElementById('qrImg');
        this.mergeImg(canvases, qrCanvas, 0);
      });

      QrCodeWithLogo.toCanvas({
        canvas: this.$refs.qrImgDown,
        content: this.url,
        width: 400,
        nodeQrCodeOptions: {
          margin: 2,
        },
        logo: {
          src: logoX2,
          logoSize: 0.25,
          logoRadius: 3,
          borderRadius: 3,
          bgColor: 'transparent'
        }
      }).then(_ => {
        const canvases = document.getElementById('qrcodeDown');
        const qrCanvas = document.getElementById('qrImgDown');
        this.mergeImg(canvases, qrCanvas, 1);
      });
    }
  },
  watch: {},
  methods: {
    mergeImg(canvases, qrCanvas, type) {
      let that = this;
      let ctx = canvases.getContext('2d');
      let width = type === 0 ? 300 : 300 * 2;
      let height = type === 0 ? 520 : 520 * 2;
      let bGHeight = type === 0 ? 160 : 160 * 2;
      let qrSize = type === 0 ? 200 : 400;
      let logoTxtWidth = type === 0 ? 80 : 80 * 2;
      let logoTxtHeight = type === 0 ? 30 : 30 * 2;

      ctx.fillStyle = '#ffffff';
      ctx.textAlign = 'center';
      // 顶部背景
      let backImg = new Image();
      backImg.src = type === 0 ? modeQrBg : modeQrBgX2;
      backImg.onload = function() {
        // that.drawRadius(ctx, 0, 0, width, bGHeight, 12, true, true, false, false);
        // ctx.clip();
        ctx.drawImage(backImg, 0, 0, width, bGHeight);
        ctx.fillStyle = '#ffffff';
        // 患者姓名
        ctx.font = (type === 0 ? 28 : 28 * 2) + 'px Calibri'; // 设置文字大小
        ctx.fillText(that.patientName ? that.patientName : '匿名', width / 2, type === 0 ? 50 : 50 * 2);
        // 科室
        ctx.font = (type === 0 ? 20 : 20 * 2) + 'px Calibri';
        ctx.fillText('3D定量分析-' + that.departmentName.split('#')[0], width / 2, type === 0 ? 90 : 90 * 2);
      };

      // 白色矩形
      ctx.textBaseline = 'top';
      ctx.fillRect(0, bGHeight, width, height - bGHeight);

      // 二维码
      let qrImg = new Image();
      qrImg.src = qrCanvas.toDataURL('image/png');
      qrImg.onload = function() {
        ctx.drawImage(qrImg, (width - qrSize) / 2, bGHeight + (type === 0 ? 40 : 40 * 2), qrSize, qrSize);
        // 微信扫一扫
        ctx.fillStyle = '#000000';
        ctx.font = (type === 0 ? 16 : 16 * 2) + 'px Calibri';
        ctx.fillText('微信扫一扫，查看3D', width / 2, bGHeight + qrSize + (type === 0 ? 40 + 10 : (40 + 10) * 2));
      };

      ctx.fillStyle = '#ffffff';
      // 虚线
      ctx.setLineDash([4, 4]);
      ctx.lineWidth = 1;
      ctx.strokeStyle = '#E6E6E6';
      ctx.beginPath();
      ctx.moveTo(32, height - logoTxtHeight * 3 + (type === 0 ? 20 : 30));
      ctx.lineTo(width - 32, height - logoTxtHeight * 3 + (type === 0 ? 20 : 30));
      ctx.stroke();
      // 底部logo
      let logoImg = new Image();
      logoImg.src = type === 0 ? logoTxt : logoTxtX2;
      logoImg.onload = function() {
        ctx.drawImage(logoImg, (width - logoTxtWidth) / 2, height - logoTxtHeight * 2, logoTxtWidth, logoTxtHeight);
      };
      // ctx.draw();

      // 如果科室名字包含有#，把#后面的文字以浅白色显示在二维码右下角
      let extName = that.departmentName.split('#');
      if (extName.length === 2) {
        extName = '#' + extName[1];
        let fontSize = (type === 0 ? 12 : 12 * 2);
        ctx.fillStyle = '#F8F8F8';
        ctx.font = fontSize + 'px Calibri';
        ctx.fillText(extName, (width - logoTxtWidth/2), height - logoTxtHeight * 1);
      }      
    },

    /**
     * 绘制指定角的圆角矩形
     * @param ctx
     * @param x 起始坐标
     * @param y 起始坐标
     * @param width 宽
     * @param height 高
     * @param radius 圆角值
     * @param tl 左上角
     * @param tr 右上角
     * @param br 右下角
     * @param bl 左下角
     */
    drawRadius(ctx, x, y, width, height, radius, tl, tr, br, bl) {
      ctx.beginPath();
      if (tl) {
        // 开始 向右挪一个圆角距离
        ctx.moveTo(x + radius, y);
        // 上边 向左挪一个圆角距离
        ctx.lineTo(x + width - radius, y);
      } else {
        // 开始 原点
        ctx.moveTo(x, y);
        // 上边 向左挪一个圆角距离
        // ctx.lineTo(x + width - radius, y);
      }

      if (tr) {
        // 右上角
        ctx.arcTo(x + width, y, x + width, y + radius, radius); // 创建弧
        // 右边 向上一个圆角距离
        ctx.lineTo(x + width, y + height - radius);
      } else {
        // 上边 没有右上角，补全上边
        ctx.lineTo(x + width, y);
        // 右边
        // ctx.lineTo(x + width, y + height - radius);
      }

      if (br) {
        // 右下角
        ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius); // 创建弧
        // 下边
        ctx.lineTo(x + radius, y + height);
      } else {
        // 右边
        ctx.lineTo(x + width, y + height);
        // 下边
        // ctx.lineTo(x + radius, y + height);
      }

      if (bl) {
        // 左下角
        ctx.arcTo(x, y + height, x, y + height - radius, radius); // 创建弧
        // 左边
        ctx.lineTo(x, y + radius);
      } else {
        // 下边
        ctx.lineTo(x, y + height);
        // 左边
        // ctx.lineTo(x, y + radius);
      }

      if (tl) {
        // 右上角
        ctx.arcTo(x, y, x + radius, y, radius); // 创建弧
      } else {
        // 左边
        ctx.lineTo(x, y);
      }
      ctx.closePath();
      ctx.strokeStyle = '#83c3e3';
      ctx.stroke(); // 绘制
    }
  }
};



// WEBPACK FOOTER //
// ./src/comp/Qrcode/_.js